export const PRIMARY_YELLOW = "#F6B547"
export const WHITE = "#FFF"
// export const WHITE = "#F6B547"


// Toast
export const TOAST_PRIMARY_GREEN = "#F6B547"
export const TOAST_SECONDARY_BLACK = "#000000"